import { get as lodashGet } from "lodash-es";
import { getIntlBody } from "main/src/js/_helpers/intl-helpers";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useProcessDetailsConfig = () => {
  const { data: config } = useInstanceConfigQuery();
  const processDetailsConfig = lodashGet(
    config,
    "custom_ui_labels.process_details",
    null
  );

  return {
    myTaskCompletedMessage:
      (processDetailsConfig &&
        getIntlBody(processDetailsConfig, "my_task_completed_message")) ||
      null,
    myGroupsCompletedMessage:
      (processDetailsConfig &&
        getIntlBody(processDetailsConfig, "my_group_completed_message")) ||
      null,
    allTaskCompletedMessage:
      (processDetailsConfig &&
        getIntlBody(processDetailsConfig, "all_task_completed_message")) ||
      null,
    shouldShowMyTaskCompletedMessage:
      processDetailsConfig &&
      processDetailsConfig.show_my_task_completed !== undefined
        ? processDetailsConfig.show_my_task_completed
        : true,
    shouldShowMyGroupsCompletedMessage:
      processDetailsConfig &&
      processDetailsConfig.show_my_group_completed !== undefined
        ? processDetailsConfig.show_my_group_completed
        : true,
    shouldShowAllTaskCompletedMessage:
      processDetailsConfig &&
      processDetailsConfig.show_all_task_completed !== undefined
        ? processDetailsConfig.show_all_task_completed
        : true
  };
};
